export enum OrderItemCircleStatus {
  NONE = 'NONE',
  AVAILABLE = 'AVAILABLE',
  CURRENT = 'CURRENT',
  PASSED = 'PASSED',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
}

export type DoorOutputConfig = {
  id: number
  name: string
  sublocationId: number
}

export enum OrderItemPickupStatus {
  NONE = 'NONE',
  NOT_PAID = 'NOT_PAID',
  NOT_STARTED = 'NOT_STARTED',
  STARTED = 'STARTED',
  PICKED_UP = 'PICKED_UP',
  RETURNED = 'RETURNED',
  ENDED = 'ENDED',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  CONSUMABLE = 'CONSUMABLE',
  CONSUMABLE_PICKEDUP = 'CONSUMABLE_PICKEDUP',
}
